export default "__VITE_ASSET__zWOit1VO__"